const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

// ── Token helpers ────────────────────────────────────────────────────────────
export const getAdminToken = () => localStorage.getItem('admin_access_token');
export const setAdminToken = (token: string) =>
  localStorage.setItem('admin_access_token', token);
export const clearAdminToken = () => {
  localStorage.removeItem('admin_access_token');
  localStorage.removeItem('admin_user');
};

const authHeaders = () => {
  const token = getAdminToken();
  console.log('TOKEN NO LOCALSTORAGE:', token);
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  };
};

// ── Auth ─────────────────────────────────────────────────────────────────────
export const adminLogin = async (username: string, password: string) => {
  const res = await fetch(`${API_BASE}/admin/auth/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ username, password }),
  });
  if (!res.ok) throw new Error((await res.json()).message || 'Erro ao autenticar');
  return res.json();
};

export const adminMe = async () => {
  const res = await fetch(`${API_BASE}/admin/auth/me`, { headers: authHeaders() });
  if (!res.ok) throw new Error('Não autenticado');
  return res.json();
};

// ── Servidores ────────────────────────────────────────────────────────────────
export const adminListarServidores = async (params?: {
  page?: number; limit?: number; search?: string; oficio?: boolean;
}) => {
  const p = new URLSearchParams({
    page: String(params?.page || 1),
    limit: String(params?.limit || 20),
    search: params?.search || '',
  });
  if (typeof params?.oficio === 'boolean') {
    p.set('oficio', String(params.oficio));
  }
  const res = await fetch(`${API_BASE}/servidores?${p}`, { headers: authHeaders() });
  if (!res.ok) throw new Error('Erro ao listar servidores');
  return res.json(); // retorna { data, total, page, limit, totalPages }
};

export const adminBaixarServidoresXlsx = async () => {
  const res = await fetch(`${API_BASE}/servidores/download`, {
    headers: { Authorization: `Bearer ${getAdminToken()}` },
  });

  if (!res.ok) throw new Error('Erro ao baixar servidores');

  const blob = await res.blob();
  const contentDisposition = res.headers.get('content-disposition') || '';
  const match = contentDisposition.match(/filename="?([^";]+)"?/i);
  const filename = match?.[1] || 'servidores.xlsx';

  return { blob, filename };
};

export const adminBuscarServidor = async (id: number) => {
  const res = await fetch(`${API_BASE}/servidores/cpf/${id}`, { headers: authHeaders() });
  if (!res.ok) throw new Error('Erro ao buscar servidor');
  return res.json();
};

export const adminBuscarServidorPorId = async (id: number) => {
  // via documentos service que carrega o servidor
  const res = await fetch(`${API_BASE}/documentos/servidor/${id}`, { headers: authHeaders() });
  if (!res.ok) throw new Error('Erro ao buscar documentos');
  return res.json();
};

export const adminAtualizarServidor = async (id: number, data: any) => {
  const res = await fetch(`${API_BASE}/servidores/${id}`, {
    method: 'PUT',
    headers: authHeaders(),
    body: JSON.stringify(data),
  });
  if (!res.ok) throw new Error('Erro ao atualizar servidor');
  return res.json();
};

// ── Documentos ────────────────────────────────────────────────────────────────
export const adminListarDocumentos = async (params?: {
  page?: number; limit?: number;
  filtro?: 'assinados' | 'pendentes';
  search?: string;
}) => {
  const p = new URLSearchParams({
    page: String(params?.page || 1),
    limit: String(params?.limit || 20),
  });
  if (params?.filtro) p.set('filtro', params.filtro);
  if (params?.search) p.set('search', params.search);
  const res = await fetch(`${API_BASE}/documentos/admin/todos?${p}`, { headers: authHeaders() });
  if (!res.ok) throw new Error('Erro ao listar documentos');
  return res.json();
};

export const adminUploadDocumento = async (
  servidorId: number,
  file: File,
  tipo: string,
) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('tipo', tipo);

  const res = await fetch(`${API_BASE}/documentos/admin/upload/${servidorId}`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${getAdminToken()}` },
    body: formData,
  });
  if (!res.ok) throw new Error('Erro ao fazer upload');
  return res.json();
};

export const adminBuscarDocumentosServidor = async (servidorId: number) => {
  const res = await fetch(`${API_BASE}/documentos/servidor/${servidorId}`, {
    headers: authHeaders(),
  });
  if (!res.ok) throw new Error('Erro ao buscar documentos');
  return res.json();
};

export const adminObterPdf = async (documentoId: number, servidorId: number) => {
  const res = await fetch(`${API_BASE}/documentos/${documentoId}/pdf/${servidorId}`, {
    headers: authHeaders(),
  });
  if (!res.ok) throw new Error('Erro ao obter PDF');
  return res.json();
};

// ── Estatísticas ──────────────────────────────────────────────────────────────
export const adminEstatisticas = async () => {
  // Combina dados de servidores e documentos
  const [servidores, documentos] = await Promise.all([
    adminListarServidores(),
    adminListarDocumentos(),
  ]);

  const assinados = documentos.filter((d: any) => d.status === 'ASSINADO').length;
  const pendentes = documentos.filter((d: any) => d.status === 'PENDENTE').length;

  return {
    total_servidores: servidores.length,
    total_documentos: documentos.length,
    documentos_assinados: assinados,
    documentos_pendentes: pendentes,
  };
};